import React from "react";

const loggedUser = React.createContext({
    loggedUser:{},
    setLoggedUser:()=>{}
})

export default loggedUser